import { Button, Grid, SelectField, TextField } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import RemoveIcon from "@mui/icons-material/RemoveCircleOutline";

import { listVariables } from "graphql/queries";

const DeviceVariableForm = ({
  initialValues,
  onChangeVariables,
  refreshInitialValues,
}) => {
  const [deviceVariableList, setDeviceVariableList] = useState([]);
  const [variables, setVariables] = useState([]);

  const onChange = (index, value) => {
    setDeviceVariableList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated[index] = {
        ...listUpdated[index],
        calibrationFactor: value,
      };
      if (onChangeVariables) onChangeVariables(listUpdated);
      return listUpdated;
    });
  };

  const onDelete = (index) => {
    setDeviceVariableList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated.splice(index, 1);
      if (onChangeVariables) onChangeVariables(listUpdated);
      return listUpdated;
    });
  };

  const onSelect = (e) => {
    const { value } = e.target;

    setDeviceVariableList((prevSt) => {
      const listUpdated = [
        ...prevSt,
        {
          variableID: value,
          calibrationFactor: 0,
        },
      ];
      if (onChangeVariables) onChangeVariables(listUpdated);
      return listUpdated;
    });
  };

  async function fetchVariables() {
    try {
      const variablesData = await API.graphql(graphqlOperation(listVariables));
      const variablesItems = variablesData.data.listVariables.items;
      setVariables(variablesItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchVariables);
    }
  }

  useEffect(() => {
    setDeviceVariableList(initialValues ?? []);
  }, [initialValues, refreshInitialValues]);

  useEffect(() => {
    fetchVariables();
  }, []);

  return (
    <Grid rowGap="15px">
      <Grid templateColumns={{ base: "1fr" }} rowGap="15px" columnGap="15px">
        <SelectField
          name="variable"
          label={strings.fields.addVariable.label}
          onChange={onSelect}
        >
          <option value="">{strings.selectOption}</option>
          {variables
            ?.filter(
              (variable) =>
                !deviceVariableList?.some(
                  (devVar) => devVar.variableID === variable.id
                )
            )
            .map((variable) => (
              <option key={variable.id} value={variable.id}>
                {variable.name}
              </option>
            ))}
        </SelectField>
      </Grid>
      <Grid
        templateColumns={{ base: "1fr", large: "2fr 2fr" }}
        rowGap="15px"
        columnGap="15px"
      >
        {deviceVariableList?.map((devVar, index) => (
          <TextField
            key={index}
            type="number"
            label={`${
              variables?.find((variable) => variable.id === devVar.variableID)
                ?.name
            } - ${strings.fields.calibrationFactor.label}`}
            value={devVar.calibrationFactor}
            onChange={(e) => onChange(index, Number(e.target.value))}
            outerEndComponent={
              <Button onClick={() => onDelete(index)}>
                <RemoveIcon />
              </Button>
            }
          ></TextField>
        ))}
      </Grid>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    selectOption: "Seleccione una opción",
    fields: {
      addVariable: {
        label: "Agregar Variable",
      },
      calibrationFactor: {
        label: "Factor de Calibración",
      },
    },
    responses: {
      errorFetchVariables: "Error al consultar variables",
    },
  },
});

export default DeviceVariableForm;
